import Cookies from 'js-cookie';
import { addToCart, fetchCart } from "../../node_modules/shops-query/src/modules/cart/index.js";

export const getGuestCart = () => {
  try {
    const guestCart = Cookies.get('guest_cart');
    const result = guestCart ? JSON.parse(guestCart) : [];
    return result;
  } catch (error) {
    console.error('Error getting guest cart:', error);
    return [];
  }
};

export const addToGuestCart = (product) => {
  try {
    const guestCart = getGuestCart();
    const existingItemIndex = guestCart.findIndex(
      item => item.productId === product.productId
    );

    if (existingItemIndex >= 0) {
      guestCart[existingItemIndex].quantity += product.quantity;
    } else {
      guestCart.push({
        productId: product.productId,
        quantity: product.quantity,
        name: product.name,
        prize: product.price,
        Discount: product.discount,
        tax: product.tax,
        featureImage: product.featureImage
      });
    }

    Cookies.set('guest_cart', JSON.stringify(guestCart), { expires: 7 });
    // Dispatch event so cart page updates
    window.dispatchEvent(new Event('cartUpdated'));
    return true;
  } catch (error) {
    console.error("Error adding to guest cart:", error);
    return false;
  }
};

export const removeFromGuestCart = (productId) => {
  try {
    const guestCart = getGuestCart();
    const updatedCart = guestCart.filter(item => item.productId !== productId);
    Cookies.set('guest_cart', JSON.stringify(updatedCart), { expires: 7 });
    // Dispatch event so cart page updates
    window.dispatchEvent(new Event('cartUpdated'));
    return true;
  } catch (error) {
    console.error('Error removing from guest cart:', error);
    return false;
  }
};

export const updateGuestCartQuantity = (productId, quantity) => {
  try {
    const guestCart = getGuestCart();
    const updatedCart = guestCart.map(item =>
      item.productId === productId ? { ...item, quantity } : item
    );
    Cookies.set('guest_cart', JSON.stringify(updatedCart), { expires: 7 });
    // Dispatch event so cart page updates
    window.dispatchEvent(new Event('cartUpdated'));
    return true;
  } catch (error) {
    console.error('Error updating guest cart:', error);
    return false;
  }
};

export const clearGuestCart = () => {
  Cookies.remove('guest_cart');
  window.dispatchEvent(new Event('cartUpdated'));
};


// Migrate guest cart items to user cart after login
export const migrateGuestCartToUserCart = async (userId, shopId) => {
  const guestCart = getGuestCart();

  if (!guestCart || !guestCart.length) {
    return; // No items to migrate
  }

  try {
    // Get the user's current cart to check for existing items
    const userCart = await fetchCart(shopId, Number(userId));

    for (const item of guestCart) {
      try {
        // Check if the product is already in the user's cart
        const isProductInCart = userCart.some(
          cartItem => cartItem.productId === item.productId
        );

        if (!isProductInCart) {
          // Add the product to user's cart if not already present
          await addToCart({
            userId: Number(userId),
            shopId: Number(shopId),
            productId: Number(item.productId),
            quantity: Number(item.quantity),
          });
        }
      } catch (error) {
        console.error(`Failed to migrate product ${item.productId}:`, error);
      }
    }

    // Clear guest cart after successful migration
    clearGuestCart();

    // Dispatch event to update cart count
    const updatedUserCart = await fetchCart(shopId, Number(userId));
    const count = updatedUserCart.reduce(
      (total, item) => total + (item.quantity || 1),
      0
    );
    window.dispatchEvent(new Event('cartUpdated'));

  } catch (error) {
    console.error("Error during cart migration:", error);
    throw error;
  }
};